import React, { useEffect } from "react"
import { NumberTagFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function RentalLengthField() {

	const {
		lengthOfRental,
		setLengthOfRentalInfo,
		error
	} = useReportFormInfo(reportFormData.peek().lengthOfRental, "lengthOfRental", object({ lengthOfRental: array().required("Must select a rental length").min(1, "Must select a rental length") }))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setLengthOfRentalInfo([], false)
		}
	}, [useCsv.value])

	return <NumberTagFieldSeeker
		label="Rental length"
		placeholder="Select rental length"
		value={lengthOfRental || []}
		onChange={e => setLengthOfRentalInfo(e)}
		error={error}
	/>
}